export const topics = {
    "01": "greeting",
    "02": "intro",
    "03": "consent",
    "04": "courtesy",
    "05": "talk",
    "06": "travel",
    "07": "idiom",
    "08": "idiom2",
    "09": "proverb",
};